/**
 * com.remedirx.apps.MyRemedi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AggregateData } from '../model/aggregateData';
import { FullResidentDetails } from '../model/fullResidentDetails';
import { ProfileStats } from '../model/profileStats';
import { ResidentDetailsResultResidentDetails } from '../model/residentDetailsResultResidentDetails';
import { ResidentMedOrderResult } from '../model/residentMedOrderResult';
import { ResidentNonMedOrderResult } from '../model/residentNonMedOrderResult';
import { ResidentPayorInfoResult } from '../model/residentPayorInfoResult';
import { SortFilterDto } from '../model/sortFilterDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ResidentService {

    protected basePath = 'http://localhost:3402';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Returns Single Active resident List of Medication Orders
     * Sample Call  http://URL/api/Resident/GetMedOrders?orgUnit&#x3D;875&amp;amp;residentId&#x3D;185130
     * @param orgUnit Id of the Organizational Unit to return data for
     * @param residentId Id of the Resident to return data for
     * @param orderActiveStatus Which orders to retrieve: active/disc/any
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public residentGetMedOrders(orgUnit: string, residentId: string, orderActiveStatus: 'Any' | 'Active' | 'Discontinued', observe?: 'body', reportProgress?: boolean): Observable<ResidentMedOrderResult>;
    public residentGetMedOrders(orgUnit: string, residentId: string, orderActiveStatus: 'Any' | 'Active' | 'Discontinued', observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResidentMedOrderResult>>;
    public residentGetMedOrders(orgUnit: string, residentId: string, orderActiveStatus: 'Any' | 'Active' | 'Discontinued', observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResidentMedOrderResult>>;
    public residentGetMedOrders(orgUnit: string, residentId: string, orderActiveStatus: 'Any' | 'Active' | 'Discontinued', observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling residentGetMedOrders.');
        }

        if (residentId === null || residentId === undefined) {
            throw new Error('Required parameter residentId was null or undefined when calling residentGetMedOrders.');
        }

        if (orderActiveStatus === null || orderActiveStatus === undefined) {
            throw new Error('Required parameter orderActiveStatus was null or undefined when calling residentGetMedOrders.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }
        if (residentId !== undefined && residentId !== null) {
            queryParameters = queryParameters.set('residentId', <any>residentId);
        }
        if (orderActiveStatus !== undefined && orderActiveStatus !== null) {
            queryParameters = queryParameters.set('orderActiveStatus', <any>orderActiveStatus);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ResidentMedOrderResult>(`${this.basePath}/api/Resident/GetMedOrders`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Single Active resident List of Non Medication Orders
     * Sample Call  http://URL/api/Resident/GetNonMedOrders?orgUnit&#x3D;875&amp;amp;residentId&#x3D;185130
     * @param orgUnit Id of the Organizational Unit to return data for
     * @param residentId Id of the Resident to return data for
     * @param orderActiveStatus Which orders to retrieve: active/disc/any
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public residentGetNonMedOrders(orgUnit: string, residentId: string, orderActiveStatus: 'Any' | 'Active' | 'Discontinued', observe?: 'body', reportProgress?: boolean): Observable<ResidentNonMedOrderResult>;
    public residentGetNonMedOrders(orgUnit: string, residentId: string, orderActiveStatus: 'Any' | 'Active' | 'Discontinued', observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResidentNonMedOrderResult>>;
    public residentGetNonMedOrders(orgUnit: string, residentId: string, orderActiveStatus: 'Any' | 'Active' | 'Discontinued', observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResidentNonMedOrderResult>>;
    public residentGetNonMedOrders(orgUnit: string, residentId: string, orderActiveStatus: 'Any' | 'Active' | 'Discontinued', observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling residentGetNonMedOrders.');
        }

        if (residentId === null || residentId === undefined) {
            throw new Error('Required parameter residentId was null or undefined when calling residentGetNonMedOrders.');
        }

        if (orderActiveStatus === null || orderActiveStatus === undefined) {
            throw new Error('Required parameter orderActiveStatus was null or undefined when calling residentGetNonMedOrders.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }
        if (residentId !== undefined && residentId !== null) {
            queryParameters = queryParameters.set('residentId', <any>residentId);
        }
        if (orderActiveStatus !== undefined && orderActiveStatus !== null) {
            queryParameters = queryParameters.set('orderActiveStatus', <any>orderActiveStatus);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ResidentNonMedOrderResult>(`${this.basePath}/api/Resident/GetNonMedOrders`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Single Active resident List of Payment Info
     * Sample Call  http://URL/api/Resident/GetPaymentInfo?orgUnit&#x3D;875&amp;amp;residentId&#x3D;185130
     * @param orgUnit Id of the Organizational Unit to return data for
     * @param residentId Id of the Resident to return data for
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public residentGetPaymentInfo(orgUnit: string, residentId: string, observe?: 'body', reportProgress?: boolean): Observable<ResidentPayorInfoResult>;
    public residentGetPaymentInfo(orgUnit: string, residentId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResidentPayorInfoResult>>;
    public residentGetPaymentInfo(orgUnit: string, residentId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResidentPayorInfoResult>>;
    public residentGetPaymentInfo(orgUnit: string, residentId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling residentGetPaymentInfo.');
        }

        if (residentId === null || residentId === undefined) {
            throw new Error('Required parameter residentId was null or undefined when calling residentGetPaymentInfo.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }
        if (residentId !== undefined && residentId !== null) {
            queryParameters = queryParameters.set('residentId', <any>residentId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ResidentPayorInfoResult>(`${this.basePath}/api/Resident/GetPaymentInfo`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Single Active resident personal info
     * Sample Call  http://URL/api/Resident/GetPersonalInfo?orgUnit&#x3D;875&amp;amp;residentId&#x3D;185130
     * @param orgUnit Id of the Organizational Unit to return data for
     * @param residentId Id of the Resident to return data for
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public residentGetPersonalInfo(orgUnit: string, residentId: string, observe?: 'body', reportProgress?: boolean): Observable<FullResidentDetails>;
    public residentGetPersonalInfo(orgUnit: string, residentId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FullResidentDetails>>;
    public residentGetPersonalInfo(orgUnit: string, residentId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FullResidentDetails>>;
    public residentGetPersonalInfo(orgUnit: string, residentId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling residentGetPersonalInfo.');
        }

        if (residentId === null || residentId === undefined) {
            throw new Error('Required parameter residentId was null or undefined when calling residentGetPersonalInfo.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }
        if (residentId !== undefined && residentId !== null) {
            queryParameters = queryParameters.set('residentId', <any>residentId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<FullResidentDetails>(`${this.basePath}/api/Resident/GetPersonalInfo`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Single Active resident profile stats
     * Sample Call  http://URL/api/Resident/GetProfileStats?orgUnit&#x3D;875&amp;amp;residentId&#x3D;185130
     * @param orgUnit Id of the Organizational Unit to return data for
     * @param residentId Id of the Resident to return data for
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public residentGetProfileStats(orgUnit: string, residentId: string, observe?: 'body', reportProgress?: boolean): Observable<ProfileStats>;
    public residentGetProfileStats(orgUnit: string, residentId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProfileStats>>;
    public residentGetProfileStats(orgUnit: string, residentId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProfileStats>>;
    public residentGetProfileStats(orgUnit: string, residentId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling residentGetProfileStats.');
        }

        if (residentId === null || residentId === undefined) {
            throw new Error('Required parameter residentId was null or undefined when calling residentGetProfileStats.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }
        if (residentId !== undefined && residentId !== null) {
            queryParameters = queryParameters.set('residentId', <any>residentId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ProfileStats>(`${this.basePath}/api/Resident/GetProfileStats`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Raw data for Resident Details (Grid Data).
     * Data in this call is not aggregated.        Sample Call      http://URL/api/Resident/GetResidentDetails?orgUnit&#x3D;875
     * @param orgUnit Id of the Organizational Unit to return data for
     * @param sortFilterDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public residentGetResidentDetails(orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'body', reportProgress?: boolean): Observable<ResidentDetailsResultResidentDetails>;
    public residentGetResidentDetails(orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResidentDetailsResultResidentDetails>>;
    public residentGetResidentDetails(orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResidentDetailsResultResidentDetails>>;
    public residentGetResidentDetails(orgUnit: string, sortFilterDto: SortFilterDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling residentGetResidentDetails.');
        }

        if (sortFilterDto === null || sortFilterDto === undefined) {
            throw new Error('Required parameter sortFilterDto was null or undefined when calling residentGetResidentDetails.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ResidentDetailsResultResidentDetails>(`${this.basePath}/api/Resident/GetResidentDetails`,
            sortFilterDto,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns active residents grouped by Payor type
     * Sample Call  http://URL/api/Resident/GetResidentDetailsByPayorType?orgUnit&#x3D;875
     * @param orgUnit Id of the Organizational Unit to return data for
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public residentGetResidentDetailsByPayorType(orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public residentGetResidentDetailsByPayorType(orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public residentGetResidentDetailsByPayorType(orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public residentGetResidentDetailsByPayorType(orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling residentGetResidentDetailsByPayorType.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<AggregateData>>(`${this.basePath}/api/Resident/GetResidentDetailsByPayorType`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
